import React from 'react';
import { Link } from 'react-router-dom';

const Home: React.FC = () => {
  return (
    <div>
      {/* Hero Section */}
      <div className="py-5 mt-3 mb-5" style={{ backgroundColor: 'var(--light-color)' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12 mb-4 mb-lg-0 text-center">
              <h1 className="display-4 fw-bold mb-3">Professional Tax Solutions for Every Need</h1>
              <p className="lead mb-4">
                Sterling Tax Solutions provides expert services to individuals and businesses navigating tax filing, planning, and compliance.
              </p>
              <div className="d-flex justify-content-center gap-2">
                <Link to="/appointments" className="btn btn-primary btn-lg">
                  Book an Appointment
                </Link>
                <Link to="/services" className="btn btn-outline-primary btn-lg">
                  View Services and Pricing
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Services Section */}
      <div className="container mb-5">
        <div className="text-center mb-5">
          <h2 className="display-5 fw-bold">Our Tax Services</h2>
          <p className="lead">Comprehensive solutions to meet all your tax needs</p>
        </div>

        <div className="row g-4">
          <div className="col-md-4">
            <div className="card h-100">
              <div className="card-body">
                <div className="text-center mb-3">
                  <i className="bi bi-file-earmark-text" style={{ fontSize: '2.5rem', color: '#0D4D26' }}></i>
                </div>
                <h3 className="card-title h5 text-center">Personal Tax Filing</h3>
                <p className="card-text">
                  Expert preparation and filing of personal income tax returns to maximize refunds and ensure compliance.
                </p>
                <Link to="/services#personal-tax" className="btn btn-outline-primary mt-auto d-block">Learn More</Link>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="card h-100">
              <div className="card-body">
                <div className="text-center mb-3">
                  <i className="bi bi-buildings" style={{ fontSize: '2.5rem', color: '#0D4D26' }}></i>
                </div>
                <h3 className="card-title h5 text-center">GST/HST Registration & Filing</h3>
                <p className="card-text">
                  Complete assistance with GST/HST registration, filing, and compliance for businesses of all sizes.
                </p>
                <Link to="/services#gst-hst" className="btn btn-outline-primary mt-auto d-block">Learn More</Link>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="card h-100">
              <div className="card-body">
                <div className="text-center mb-3">
                  <i className="bi bi-shield-check" style={{ fontSize: '2.5rem', color: '#0D4D26' }}></i>
                </div>
                <h3 className="card-title h5 text-center">CRA Audit Defence</h3>
                <p className="card-text">
                  Professional representation and support during CRA audits to protect your interests.
                </p>
                <Link to="/services#audit-defence" className="btn btn-outline-primary mt-auto d-block">Learn More</Link>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-4">
          <Link to="/services" className="btn btn-primary">View All Services</Link>
        </div>
      </div>

      {/* Why Choose Us */}
      <div className="py-5 mb-5" style={{ backgroundColor: 'var(--light-color)' }}>
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="display-5 fw-bold">Why Choose Sterling Tax Solutions?</h2>
            <p className="lead">We're committed to excellence in every aspect of tax services</p>
          </div>

          <div className="row g-4">
            <div className="col-md-3">
              <div className="text-center">
                <i className="bi bi-award" style={{ fontSize: '2.5rem', color: '#0D4D26' }}></i>
                <h3 className="h5 mt-3">Expertise</h3>
                <p>Qualified professionals with extensive tax knowledge and experience.</p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="text-center">
                <i className="bi bi-person-check" style={{ fontSize: '2.5rem', color: '#0D4D26' }}></i>
                <h3 className="h5 mt-3">Personalized Service</h3>
                <p>Tailored solutions to meet your specific tax needs and goals.</p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="text-center">
                <i className="bi bi-shield-lock" style={{ fontSize: '2.5rem', color: '#0D4D26' }}></i>
                <h3 className="h5 mt-3">Confidentiality</h3>
                <p>Your financial information is always kept secure and private.</p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="text-center">
                <i className="bi bi-clock-history" style={{ fontSize: '2.5rem', color: '#0D4D26' }}></i>
                <h3 className="h5 mt-3">Timely Service</h3>
                <p>Prompt and efficient tax preparation and filing services.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="container mb-5">
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <div className="card sterling-bg text-center">
              <div className="card-body py-5">
                <h3 className="card-title text-white mb-3">Ready to Get Started?</h3>
                <p className="card-text text-white mb-4">
                  Contact us today to schedule a consultation and discover how we can help you with your tax needs.
                </p>
                <div className="d-flex flex-column flex-sm-row justify-content-center gap-3">
                  <Link to="/appointments" className="btn btn-light">Book an Appointment</Link>
                  <Link to="/contact" className="btn btn-outline-light">Contact Us</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home; 